// extracted by mini-css-extract-plugin
export default {"wrapper":"PasswordInput_wrapper__wRPwD","input":"PasswordInput_input__dGspl","button":"PasswordInput_button__SEorP","icon":"PasswordInput_icon__F4Z1f"};